import { Tooltip } from 'platform/components';
import { Text, ThemeTextColorPath } from 'platform/foundation-tw';
import { isNotNil } from 'ramda-adjunct';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getCellClassName } from '../../utils/getCellClassName';
import { getStylesToRender } from '../../utils/getStylesToRender';
import { getTooltipProps } from '../../utils/getTooltipProps';
type TimeIntervalCellRendererProps = CellRendererProps<number | null> & {
  getTooltipProps?: TooltipGetter;
};
type CellStyle = {
  textColor?: ThemeTextColorPath;
};
export function TimeIntervalCellRenderer(props: TimeIntervalCellRendererProps) {
  const className = getCellClassName(props.column);
  const cellStyles = getStylesToRender(props) as CellStyle | undefined;
  const tooltipProps = getTooltipProps(props.row, {}, props.getTooltipProps);
  const cellValue = isNotNil(props.value) ? String(props.value) : '';
  return <Tooltip {...tooltipProps}>
      <div className={className}>
        <Text color={cellStyles?.textColor} noWrap={!props.column?.wrapText} size="small">
          {cellValue}
        </Text>
      </div>
    </Tooltip>;
}